// action - state management
import { REGISTER, LOGIN, LOGOUT } from './actions';

// initial state
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  userData: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { userData } = action.payload;
      return {
        ...state,
        userData
      };
    }
    case LOGIN: {
      const { userData } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        userData
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        userData: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
